/**
 * The **Media Tag** vocabulary — one behaviour describing what the animal is doing, stored on the
 * media document. Mirrors `MEDIA_TAGS` in zl-api (`src/models/core/constants.ts`), which is the
 * enum the API validates against; keep the two in step, and ship the API first.
 *
 * Order is render order. `TAGS_COLLAPSED_COUNT` is where the creation modals cut the list when the
 * picker is collapsed. It is a plain count rather than a measured row count — the pills are
 * flex-wrapped and content-width driven, so "two rows" is not something the picker can know without
 * measuring the DOM.
 *
 * Distinct from an **Animal Alert** (`@/components/AnimalAlertButtons`), which is drawn as a
 * similar pill but is ephemeral, is addressed to other viewers in the habitat, and is never stored
 * on the media.
 */
export const TAGS_ENUM = [
  'Playing',
  'Resting',
  'Eating',
  'Moving',
  'Grooming',
  'Drinking',
  'Bathing',
  'Enrichment',
  'Close-up',
  'Breeding',
  'Parenting',
  'Sniffing',
  'Hunting',
] as const;

/** One value from the Media Tag vocabulary. */
export type MediaTag = (typeof TAGS_ENUM)[number];

export const TAGS_COLLAPSED_COUNT = 5;
